import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { TableColumnsType } from "antd";

import { IShortTermPlan } from "@types";
import { checkPermission } from "@/utils";
import { permissions } from "@/router";

export const getColumns = ({
  removeShortTermPlan,
  shortTermPlan_id,
  isDeleting,
  editShortTermPlan,
}: {
  removeShortTermPlan: (id: number) => Promise<void>;
  shortTermPlan_id: React.MutableRefObject<any>;
  isDeleting: boolean;
  editShortTermPlan: (selectedShortTermPlan: IShortTermPlan) => void;
}): TableColumnsType<any> => [
    {
      title: "plan name",
      dataIndex: "name",
      key: "name",
      width: 250,
      sorter: true,
    },
    {
      title: "plan type",
      dataIndex: "type",
      key: "type",
      width: 250,
      render: (type: { id: number; name: string }) => type.name,
      sorter: true,
    },
    {
      title: "grades",
      key: "grades",
      width: !checkPermission([
        permissions.DELETE_COMPANY_STI,
        permissions.UPDATE_COMPANY_STI,
      ])
        ? 200
        : 300,
      render: (plan: IShortTermPlan) => (
        <div className="text-wrap">
          {plan?.is_all_grade
            ? "All Grades"
            : plan?.grades
              ?.map((grade: any) => grade?.grade)
              .join(", ")}
        </div>
      ),
      sorter: true,
    },
    {
      title: "grade type",
      key: "type",
      width: !checkPermission([
        permissions.DELETE_COMPANY_STI,
        permissions.UPDATE_COMPANY_STI,
      ])
        ? 200
        : 300,
      render: (plan: IShortTermPlan) => (
        <div className="text-wrap">
          {plan?.is_all_grade
            ? "All Types"
            : plan?.grades
              ?.map((grade: any) => grade?.type)
              .join(", ")}
        </div>
      ),
      sorter: true,
    },
    {
      title: "Countries",
      key: "coverage",
      width: !checkPermission([
        permissions.DELETE_COMPANY_STI,
        permissions.UPDATE_COMPANY_STI,
      ])
        ? 200
        : 400,
      render: (plan: IShortTermPlan) => (
        <div className="text-wrap">
          {plan?.is_global
            ? "Global"
            : plan?.countries?.map(country => country?.name).join(", ")}
        </div>
      ),
      sorter: true,
    },
    ...(!checkPermission([
      permissions.DELETE_COMPANY_STI,
      permissions.UPDATE_COMPANY_STI,
    ])
      ? []
      : ([
        {
          title: "Actions",
          key: "actions",
          width: 160,
          fixed: "right",
          align: "center",
          render: (shortTermPlan: IShortTermPlan) => (
            <div className="flex items-center gap-2">
              {checkPermission(permissions.UPDATE_COMPANY_STI) && (
                <div
                  onClick={event => {
                    event.stopPropagation();
                    editShortTermPlan(shortTermPlan);
                  }}
                  className="table__action__btn table__action__btn--client"
                >
                  <EditOutlined style={{ color: "#1A8245" }} /> Edit
                </div>
              )}
              {checkPermission(permissions.DELETE_COMPANY_STI) && (
                <div
                  onClick={event => {
                    event.stopPropagation();
                    removeShortTermPlan(shortTermPlan?.id);
                  }}
                  className="table__action__btn table__action__btn--delete"
                >
                  {isDeleting &&
                    shortTermPlan?.id === shortTermPlan_id?.current ? (
                    <LoadingOutlined color="#B62424" className="spinner" />
                  ) : (
                    <>
                      <DeleteOutlined style={{ color: "#B62424" }} /> Delete
                    </>
                  )}
                </div>
              )}
            </div>
          ),
        },
      ] as any)),
  ];
